export default {
  evaluation_dashboard: {
    unit: ' Companies',
    average: 'Average Score:',
    point: ' points',
    answered_label: 'Submitted',
    evaluated_label: 'Assessed',
    corporate_average: "Your suppliers' average",
    points_earned_by_companies: "Your suppliers' score distribution",
    year_modal: {
      title: 'Select a year',
      label: 'Year',
    },
    response_status_title: 'Answer status distribution',
    response_status_rating_nothing: 'No answers yet',
    esg_rating_title: 'ESG rating distribution',
    esg_score_title: 'ESG Score distribution',
    category_scores_title: 'Compare scores by category',
    category_scores_distribution_title: 'Score distribution by category',
    category_score_data_all_label: "ASUENE ESG's average",
    esg_scores_by_industry_title: 'ESG score distribution by industry',
    environment_score_title: 'Environment score distribution',
    social_score_title: 'Social score distribution',
    governance_score_title: 'Governance score distribution',
    environment_score_subtitle_upper5: 'Top 5 Environment Scores',
    environment_score_subtitle_lower5: 'Worst 5 Environment Scores',
    social_score_subtitle_upper5: 'Top 5 Social Scores',
    social_score_subtitle_lower5: 'Worst 5 Social Scores',
    governance_score_subtitle_upper5: 'Top 5 Governance Scores',
    governance_score_subtitle_lower5: 'Worst 5 Governance Scores',
    empty_error_message: 'Survey has not yet been issued.',
    common: {
      update_date: 'Last updated date',
    },
    registration_rate: {
      title: 'Registration rate',
      tip: 'Companies registered in ASUENE ESG out of the total number of companies to be assessed',
    },
    answer_rate: {
      title: 'Submission rate',
      tip: 'Companies that submitted the survey out of the total number of companies to be assessed',
    },
    days_remaining: {
      title: 'Days until the end of the survey',
      tip: 'Days remaining until the deadline set.\nIf you wish to change the deadline, please contact us.',
      days_remaining_before: '',
      days_remaining_after: 'days remaining',
      expired: 'Deadline has been exceeded.',
    },
    answer_transition: {
      title: 'Submission trend',
      companies_submitted: 'Companies submitted',
      breakdown: 'Breakdown',
      unregistered: 'Unregistered',
      total: 'Total',
      number_of_companies: 'Number of companies',
    },
    answer_list: {
      title: 'Latest submission',
      submitted_at: 'Answer date',
    },
    average_score: 'Average score',
    risky_evaluation_comments: 'Risky evaluation comments',
    score_distribution: 'Score distribution',
    overall_score: 'Overall score',
    average_score_by_category: 'Average score by category',
    score_ranking: 'Score ranking',
    sort_by_lowest_score: 'Sort by lowest score',
    sort_by_highest_score: 'Sort by highest score',
    high_risk_evaluation_comments: 'High-risk evaluation comments',
  },
}